import { LinkButton } from "../../components/LinkButton";
import { MainCtaButton } from "../../components/MainCtaButton";

export default ({ data }) => {
  return (
    <section className="usecases_title_section">
      <div className="usecases_title_section-container section-layout">
        <div>
          <div className="usecases_title_section-text_container">
            <h1>{data.usecaseInfo.name}</h1>
            <p className="usecases_title_section-description">{data.usecaseInfo.description}</p>
            {data.usecaseInfo.button ? (
              <LinkButton
                download={data.usecaseInfo.button.download}
                href={data.usecaseInfo.button.url}
                variant="inverted"
                demystIcon
              >
                {data.usecaseInfo.button.text}
              </LinkButton>
            ) : (
              <MainCtaButton />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
